export default "__VITE_ASSET__BGXFPT3n__"